export const Config = {
    HTTP_API_URI: "https://api.music-chart.grimir.cz",
    WS_API_URI: "wss://api.music-chart.grimir.cz/ws"
}
